import { generateUseUseSettings } from './generateUseUsingSettings';

export const useUsingAxisSettings = generateUseUseSettings({
  slug: 'axisinsurance',
});
